module.exports = __webpack_public_path__ + "static/media/icon-score-3-scale-5.b6d99e08.svg";